import { useBaseActions } from '../base.actions';
import { configNivelFluenciasAtom } from './configNivelFluenciaState';
import { RecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useAxiosWrapper } from '../../services/axiosWrapper';
import { authAtom } from './../usuarios/AuthState';
import { history } from '../../helpers/history';

function useConfigNivelFluenciasActions() {
  const baseActions = useBaseActions('configNivelFluencias', configNivelFluenciasAtom, false);
  const axiosWrapper = useAxiosWrapper();
  const authState = useRecoilValue(authAtom);
  const setAuth = useSetRecoilState(authAtom);
 
  return {
    list,
    get: baseActions.get,
    create: baseActions.create,
    update: baseActions.update,
    delete: baseActions.delete,
  };

  async function list() {
    let url = `${process.env.REACT_APP_API_URL}/v1/assessorados/configNivelFluencias`;

    try {
      const recursos = await axiosWrapper.get(url);

      return recursos;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }

  }
}

export { useConfigNivelFluenciasActions };
